import interUrl from "./InterVariable-latin.woff2";

// Inter, the brand typeface: one variable file (Latin, weights 100–900, Inter 4 under the OFL).
// The page's HTML preloads the same file, so it is usually here before React first renders.
// Registered from script rather than CSS because Bun's CSS bundler would inline it as base64.
// Until it arrives, text uses "Inter Fallback" (globals.css), Arial sized to Inter's metrics.
if (![...document.fonts].some((face) => face.family === "Inter")) {
  document.fonts.add(new FontFace("Inter", `url(${interUrl}) format("woff2")`, { weight: "100 900", display: "swap" }));
}
